var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn arrow-btn",class:_vm.buttonClass,style:(_vm.buttonStyle),attrs:{"aria-label":_vm.ariaLabel || _vm.type},on:{"click":function($event){return _vm.$emit('click')}}},[_c('icon',{attrs:{"name":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }